import {motion} from 'motion/react';
import {Dialog, DialogContent, DialogOverlay, DialogTitle} from "./ui/dialog";
import { fs } from '../utils/a11y.js';

export function InactivityModal({
  showInactivityDialog,
  setShowInactivityDialog,
  backToCatalog,
  setCheckoutRemoteClear,
  setIsSecretMenuModalOpen,
  setIsProductModalOpen,
  handleClearCart,
  elapsedTime,
  redirectTimeout,
  logActivity,
  drawerContainer
}) {
    const handleClose = (e, log) => {
      if (e) e.stopPropagation();
      if (log) logActivity('inactivity-dialog', 'close-button/overlay', 'click', true, null);
      setShowInactivityDialog(false);
    };

    const handleContinue = (e) => {
      if (e) e.stopPropagation();
      logActivity('inactivity-dialog', 'continue-button', 'click', true, null);
      handleClose(e, false);
    };

    const handleBackToCatalog = (e) => {
      logActivity('inactivity-dialog', 'catalog-button', 'click', true, null);
      handleClose(e, false);
      setIsSecretMenuModalOpen(false);
      setIsProductModalOpen(false);
      setCheckoutRemoteClear(true);
      setTimeout(() => {setCheckoutRemoteClear(false)}, 10);
      backToCatalog();
      handleClearCart();
    };

    const getRemainingTime = () => {
      return redirectTimeout - elapsedTime;
    };

    return (
      <Dialog open={showInactivityDialog} onOpenChange={(e) => handleClose(e, true)}>
        <DialogContent
          aria-describedby="Inactivity Modal"
          description="Inactivity Modal"
          container={drawerContainer}
          className="bg-back shadow-2xl border-[4px] overflow-hidden max-w-[800px] w-full max-h-[calc(var(--app-h)*0.9)] overflow-y-auto sm:max-w-lg rounded-lg"
          style={{borderRadius: '24px', padding: '40px 32px'}}
        >
          <DialogTitle className="text-3xl text-center main-font-bold mb-2">
            <div className="secondary-font-bold" style={{ fontSize: fs(30), lineHeight: fs(30) }}>Alerta de inactividad</div>
          </DialogTitle>
          <div className="flex flex-col items-center justify-center">
            <div className="text-center">
              <div className="w-full h-auto mb-5 mx-auto main-font-regular">Este kiosco volverá al inicio en:</div>
              <div className="mb-4 main-font-bold" style={{ fontSize: fs(24), lineHeight: fs(32) }}>
                  {Math.ceil(getRemainingTime() / 1000)} segundo(s)
              </div>
            </div>
            <div className="space-y-3 pt-4">
              <motion.button
                type="button"
                onClick={(e) => handleContinue(e)}
                disabled={false}
                className="w-full btn btn-primary text-center text-[#FAFAFA]"
                style={{height: '64px', fontSize: fs(18), lineHeight: fs(27)}}
                whileTap={{ scale: 0.98 }}
                animate={{boxShadow: ['0px 0px 30px 0px var(--color-primary-glow)', '0px 0px 30px 15px var(--color-primary-glow)', '0px 0px 30px 0px var(--color-primary-glow)']}}
                transition={{delay: 0, duration: 2, repeat: Infinity, ease: 'linear'}}
              >
                <span className='text-3xl'>Continuar</span>
              </motion.button>
              <button
                type="button"
                onClick={(e) => handleBackToCatalog(e)}
                disabled={false}
                className="w-full text-center secondary-font-bold"
                style={{color: 'var(--color-text-muted)', fontSize: fs(16), lineHeight: fs(24), padding: '12px 0'}}>
                  Volver al catálogo
                </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
}